import { RepoType } from '@amzn/awscat-pattern-library-service-model';
import React, { useContext } from 'react';
import constants from '../../../../../common/constants';
import { CodeRepoFormCtx } from './CodeRepoFormContext';
import { InputValidation } from './ValidationHook';
import { InputFormField } from './InputFormField';
import {
  requiredFieldValidation,
  inputLengthValidation,
  validUrlValidation,
  urlContainsPathValidation,
  allowedInternalRepoUrlValidation,
  allowedExternalRepoUrlValidation,
  allowedGithubRepoValidation,
  codeAmazonPathValidation,
  githubPathValidation,
  gitlabPathValidation,
  codeAWSPathValidation,
} from './Validations';

export const RepositoryUrlFormField = () => {
  // @ts-expect-error TS2339 - strict migration
  const { repoData } = useContext(CodeRepoFormCtx);
  const validations: InputValidation[] = [
    requiredFieldValidation,
    inputLengthValidation,
    validUrlValidation,
    urlContainsPathValidation,
    allowedGithubRepoValidation,
    codeAmazonPathValidation,
    codeAWSPathValidation,
    githubPathValidation,
    gitlabPathValidation,
  ];
  if (repoData.repoType === RepoType.Internal) {
    validations.push(allowedInternalRepoUrlValidation);
  } else {
    validations.push(allowedExternalRepoUrlValidation);
  }
  validations.push(allowedGithubRepoValidation);

  const updateUrl = (newValue: string) => ({ url: newValue });

  return (
    <InputFormField
      fieldId="url"
      label="Repository URL*"
      placeholder={constants.CODE_REPO_PLACEHOLDER}
      value={repoData.url}
      setValue={updateUrl}
      validations={validations}
    />
  );
};
